export const QUERY_KEYS = {
  User: ['user'] as const,
  OrganizationMembers: (params: {
    organizationId: string | null;
    [key: string]: string | number | boolean | null | undefined;
  }) => ['organizationMembers', params] as const,
  FeatureFlags: (params: { organizationId: string | null }) => ['featureFlags', params] as const,
  ClientAccountNames: (params: { organizationId: string | null }) => ['clientAccountNames', params] as const,
  ClientStorageFiles: (params: { organizationId: string | null; clientAccountId: string | null; basePath: string }) =>
    ['clientStorageFiles', params] as const,
} as const;
